export const PHC_ACCESS_ROLES = ["phc-admin", "phc-user"] as const

export type PHCAccessRole = (typeof PHC_ACCESS_ROLES)[number]

export const hasRole = (roles: string[] | undefined, role: string): boolean => {
  return !!roles?.includes(role)
}

export const hasAnyRole = (
  roles: string[] | undefined,
  allowedRoles: readonly string[]
): boolean => {
  if (!roles?.length || !allowedRoles.length) {
    return false
  }
  return allowedRoles.some(role => roles.includes(role))
}

export const hasPHCAccessRole = (roles: string[] | undefined): boolean => {
  return hasAnyRole(roles, PHC_ACCESS_ROLES)
}
